import { useError } from "../../context/useErrorContext"
import { GetRequest } from "../../services/ApiClientService"
import { API_ROUTES } from "../../configuration/RoutesApi"
import { ERequestType } from "../../Enum/ERequestType"
import { useTranslation } from "react-i18next"

export interface ResellerOverview {
  totalClients: number
  activeClients: number
  monthlyRecurringAmount: number
  commissionAccrued: number
  commissionPaid: number
  commissionPending: number
}

export const useGetResellerOverview = () => {
  const { t } = useTranslation("general")

  const { setError } = useError()

  const handleGetResellerOverview = async (onSuccess: (overview: ResellerOverview) => void) => {
    try {
      const response = await GetRequest<ResellerOverview>(API_ROUTES.RESELLER.OVERVIEW, ERequestType.Reseller)

      if (response.success && response.data) {
        onSuccess(response.data)

        return
      }

      throw new Error(response.message)
    } catch (e: unknown) {
      const message = e instanceof Error ? e.message : t("label_unknown_error_description")

      setError(t("label_title_erro"), message)
    }
  }

  return { handleGetResellerOverview }
}
